
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';
import { performGlobalLogout } from './authSlice';

export const fetchMessage = createAsyncThunk(
  'message/fetchMessage',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/message');
    
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || 'Failed to fetch message'
      );
    }
  }
);

const messageSlice = createSlice({
  name: 'message',
  initialState: {
    text: '',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessage.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.text = action.payload;
      })
      .addCase(fetchMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(performGlobalLogout.fulfilled, (state) => {
        state.text = '';
        state.loading = false;
        state.error = null;
      });
  }
});

export default messageSlice.reducer;

